import { useEffect } from "react";
import { useAppDispatch } from "./storeHooks";

export const useTabClose = (handleTabClose: (event?: BeforeUnloadEvent) => void) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    window.addEventListener('beforeunload', handleTabClose);
    return () => {
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, [dispatch, handleTabClose]);
}